<div *ngIf='ionFunction' style="padding:8px" [width]='width' [innerHTML]='safe(getHTML())'>
</div>
<div *ngIf='html' style="padding:8px" [innerHTML]='safe(html)'   (click)="onHtmlClick()">
</div>